const API_BASE = process.env.REACT_APP_API_URL || '/api';

async function request(path, options = {}) {
    const headers = {
        'Content-Type': 'application/json',
        ...(options.headers || {}),
    };

    if (options.wallet) {
        headers['X-Wallet-Address'] = options.wallet;
    }

    const response = await fetch(`${API_BASE}${path}`, {
        ...options,
        headers,
    });

    const data = await response.json().catch(() => ({}));
    if (!response.ok) {
        throw new Error(data.error || `Request failed (${response.status})`);
    }
    return data;
}

export const api = {
    health: () => request('/health'),
    stats: () => request('/stats'),
    getWills: (params = {}, wallet) => {
        const query = new URLSearchParams();
        Object.entries(params).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== '') {
                query.set(key, value);
            }
        });
        const suffix = query.toString() ? `?${query.toString()}` : '';
        return request(`/wills${suffix}`, { wallet });
    },
    getWill: (id) => request(`/wills/${id}`),
    claimWill: (id, wallet) => request(`/wills/${id}/claim`, {
        method: 'POST',
        wallet,
    }),
    search: (q) => request(`/search?q=${encodeURIComponent(q)}`),
    getMe: (wallet) => request('/users/me', { wallet }),
    updateMe: (wallet, body) => request('/users/me', {
        method: 'PATCH',
        wallet,
        body: JSON.stringify(body),
    }),
};
